import { timer } from 'rxjs';
import {Component, OnInit, Input} from '@angular/core';
import {CommunicationService} from '../../services/communication.service';
import {HasSubscriptions} from '../has-subscriptions';
import {Helper} from '../../classes/helper';
import {animate, style, transition, trigger, state} from '@angular/animations';
import {DeviceService} from '../../services/device/device.service';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss'],
  animations: [
    trigger('notification', [
      state('hidden', style({
        top: '-36px',
        display: 'none'
      })),
      state('show', style({
        display: 'initial',
        top: '0px',
      })),
      transition('show <=> hidden', animate('250ms ease-in')),
    ]),
    trigger('bottomNotification', [
      state('hiddenBottom', style({
        bottom: '-36px',
        display: 'none',
        height: '0',
        padding: '0',
      })),
      state('showBottom', style({
        display: 'initial',
        bottom: '0px',
        height: '15%',
      })),
      transition('showBottom <=> hiddenBottom', animate('250ms ease-in')),
    ]),
  ]
})
export class NotificationsComponent extends HasSubscriptions implements OnInit {
  @Input() isTemporary: boolean = true;

  // TODO: I hate everything about this bottom notification
  @Input() isBottomNotification: boolean = false;
  @Input() notificationLifeSpan: number = 750;
  currentNotification: String;
  enableNotification: boolean = true;
  state: string = 'hidden';
  stateBottom: string = 'hiddenBottom';
  subscription;

  constructor(private communicationService: CommunicationService,
              private deviceService: DeviceService) {
    super();
  }

  ngOnInit() {
    if (!this.isBottomNotification) {
      this.addSub(this.communicationService.notifications.notificationChanged.subscribe(async notification => {
        this._setNotification(notification);
      }));
    } else {
      this.addSub(this.communicationService.notifications.bottomNotification.subscribe(async n => {
        this._setNotification(n);
      }));
    }

    this.addSub(this.communicationService.notifications.enableNotifications.subscribe((status) => {
      if (this.subscription) {
        this.subscription.unsubscribe();
      }
      this.subscription = timer(150).subscribe(() => {
        this.enableNotification = status;
      });
    }));
  }

  private async _setNotification(notification: string) {
    this.currentNotification = notification;
    if (notification && notification.length > 0) {
      if (this.isBottomNotification) this.stateBottom = 'showBottom';
      else this.state = 'show';
    } else {
      this.state = 'hidden';
      this.stateBottom = 'hiddenBottom';
    }
    if (this.deviceService.isMobileDevice() && this.isTemporary) {
      await timer(this.notificationLifeSpan).toPromise();
      if (this.currentNotification === notification) {
        // i.e. unless this notification has been interrupted by another one ...
        this.currentNotification = null;
        this.state = 'hidden';
        this.stateBottom = 'hiddenBottom';
      }
    }
  }


}
